import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, CreditCard } from 'lucide-react';
export function Hero() {
  return <section className="bg-cream pt-5 pb-6 md:pt-10 md:pb-10 px-4 relative overflow-hidden" data-id="element-118">
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-gold/10 rounded-full blur-[140px] pointer-events-none" data-id="element-119"></div>

      <div className="max-w-5xl mx-auto relative z-10 text-center" data-id="element-120">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-121">
          <span className="inline-block text-[10px] md:text-sm text-ink bg-surface border border-border rounded-full px-3 py-0.5 md:px-4 md:py-1 mb-2 md:mb-4 font-medium shadow-sm" data-id="element-122">
            💰 BibliotecaDigital.online
          </span>
          <h1 className="font-bold text-ink mb-2 md:mb-3 text-2xl sm:text-4xl md:text-6xl leading-tight whitespace-nowrap" data-id="element-123">
            MENOS CAOS + CONTROL
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="my-3 md:my-8" data-id="element-124">
          <img src="https://cdn.magicpatterns.com/uploads/8x1RWJ9e5b4sCEhbHSPm5D/Diseno_sin_titulo_(14).png" alt="Dominio Financiero" className="w-full max-w-[240px] md:max-w-[460px] mx-auto drop-shadow-[0_25px_60px_rgba(0,0,0,0.25)]" data-id="element-125" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} data-id="element-126">
          <p className="text-ink text-base md:text-2xl max-w-2xl mx-auto mb-1.5 md:mb-3 font-bold font-serif px-2" data-id="element-127">
            ¿Cobrás y a los pocos días ya no tenés más?
          </p>
          <p className="text-muted text-xs md:text-lg max-w-2xl mx-auto mb-3 md:mb-8 px-2 leading-snug" data-id="element-128">
            La guía definitiva para dejar de preguntarte a dónde se fue tu
            sueldo y empezar a decidir a dónde va.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="max-w-2xl mx-auto" data-id="element-129">
          <a href="#pricing" className="inline-block bg-gradient-to-b from-[#F2D87A] via-[#C9A84C] to-[#8A6E2A] hover:from-[#F5DE8C] hover:via-[#D4B45A] hover:to-[#9A7E36] text-ink font-bold text-xs md:text-xl py-3 px-5 md:py-4 md:px-10 rounded-full shadow-[0_10px_30px_rgba(138,110,42,0.45),inset_0_1px_0_rgba(255,255,255,0.5)] border border-[#8A6E2A]/40 transition-all hover:scale-105 active:scale-95 mb-3 md:mb-6 leading-tight" data-id="element-130">
            👉 QUIERO TOMAR EL CONTROL DE MI PLATA AHORA
          </a>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 md:gap-5 text-[11px] md:text-sm text-muted font-medium" data-id="element-131">
            <div className="flex items-center" data-id="element-132">
              <Shield className="w-3 h-3 md:w-4 md:h-4 mr-1 text-success" data-id="element-133" />{' '}
              Garantía 7 días
            </div>
            <div className="flex items-center" data-id="element-134">
              <Lock className="w-3 h-3 md:w-4 md:h-4 mr-1 text-success" data-id="element-135" /> Pago
              seguro
            </div>
            <div className="flex items-center" data-id="element-136">
              <CreditCard className="w-3 h-3 md:w-4 md:h-4 mr-1 text-success" data-id="element-137" />{' '}
              Mercado Pago
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}